import React, {useState, useEffect} from "react";

import {Grid, Tab, Tabs} from "@mui/material";
import RetailCostAndMargin from "./tabs/RetailCostAndMargin/RetailCostAndMargin";
import {
    RETAIL_PROCUREMENT,
    RETAIL_REPORTS,
    RETAIL_TABS,
    RETAIL_EMPLOYEES,
    ALPINEIQ,
    RETAIL_ROUTES,
} from "../../constants";
import {useNavigate, useSearchParams} from "react-router-dom";
import {getCookie, isEmpty} from "weed-js";
import {fetchLeaflogixAccounts, fetchMetrcAccounts} from "../../../../redux/models/integrations/Action";
import { useDispatch, useSelector } from "react-redux";
import Enrollment from "../../../../components/reports/alpineiq/Enrollment";
import Engagement from "../../../../components/reports/alpineiq/Engagement";
import Redemption from "../../../../components/reports/alpineiq/Redemption";
import CustomerLifetimeValue from "../../../../components/reports/alpineiq/CustomerLifetimeValue";
import PercentOfRevenue from "../../../../components/reports/alpineiq/PercentOfRevenue";
import {INTEGRATIONS, DUTCHIE, METRC} from "../../../../constants";
import RetailProcurement from "./tabs/RetailProcurement/RetailProcurement";
import {setMetrcAccounts, setDutchieAccounts} from "../../../../redux/models/integrations/Action";
import {CanonicalIntegrationAccount} from "../../../../models/canonical";
import {MetrcAccount} from "../../../../models/metrc";
import {DutchieAccount} from "../../../../models/dutchie";


export const Retail = ({client, tab, selectedOrganization, verticals, categories, availableViews, setAvailableViews}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const whichTab = searchParams.get("subtab") || RETAIL_TABS[RETAIL_REPORTS];
    const [selectedTab, setSelectedTab] = useState(whichTab ? parseInt(whichTab) : null);
    const selectedIntegration = useSelector(state => state.integrationReducer.selectedIntegration);
    const dispatch = useDispatch();
    const abortController = new AbortController();

    useEffect(() => {
        if (isEmpty(selectedOrganization) || isEmpty(selectedIntegration)) {
            return;
        }

        if (selectedIntegration === METRC) {
            dispatch(fetchMetrcAccounts({
                organization_id: selectedOrganization.id
            }, abortController)).then((fetchedMetrcAccounts) => {
                fetchedMetrcAccounts.map(acc => {
                    let ma = MetrcAccount.byId.get(acc.id);
                    if (!ma) ma = new MetrcAccount(acc);
                    CanonicalIntegrationAccount.fromMetrc(ma);
                });
                setMetrcAccounts(fetchedMetrcAccounts);
            });
        }

        if (selectedIntegration === DUTCHIE) {
            dispatch(fetchLeaflogixAccounts({
                organization_id: selectedOrganization.id
            })).then((fetchedLeaflogixAccounts) => {
                fetchedLeaflogixAccounts.map(acc => {
                    let da = DutchieAccount.byId.get(acc.id);
                    if (!da) da = new DutchieAccount(acc);
                    CanonicalIntegrationAccount.fromDutchie(da);
                });
                setDutchieAccounts(fetchedLeaflogixAccounts);
            });
        }

        return () => {
            abortController.abort();
        };
    }, [selectedOrganization, selectedIntegration]);

    const TabPanel = ({children, index}) => {
        if (index === selectedTab) {
            return <>{children}</>;
        }
        return "";
    };

    const selectTab = (event, newValue) => {
        setSelectedTab(newValue);
        // keep path the same; update ?tab=...
        setSearchParams(prev => {
            const p = new URLSearchParams(prev);
            p.set("subtab", String(newValue));
            return p;
        });
    };


    return <Grid container spacing={12} className={"report-body"}>
        <Grid item xs={12}>
            <Tabs 
                value={selectedTab} 
                onChange={selectTab}
                variant="scrollable"
                scrollButtons={true}
                allowScrollButtonsMobile={true}
            >
                <Tab disabled={isEmpty(selectedOrganization)}
                    label={RETAIL_REPORTS}
                    value={RETAIL_TABS[RETAIL_REPORTS]}
                    tabIndex={RETAIL_TABS[RETAIL_REPORTS]}
                    id={"retail-cost-and-margin-tab"}/>
                <Tab disabled={isEmpty(selectedOrganization)}
                    label={RETAIL_PROCUREMENT}
                    value={RETAIL_TABS[RETAIL_PROCUREMENT]}
                    tabIndex={RETAIL_TABS[RETAIL_PROCUREMENT]}
                    id={"retail-procurement-tab"}/>
                {/*<Tab disabled={isEmpty(selectedOrganization)}*/}
                {/*    label={RETAIL_EMPLOYEES}*/}
                {/*    value={RETAIL_TABS[RETAIL_EMPLOYEES]}*/}
                {/*    tabIndex={RETAIL_TABS[RETAIL_EMPLOYEES]}*/}
                {/*    id={"retail-employees-tab"}/>*/}
            </Tabs>
            <TabPanel index={RETAIL_TABS[ALPINEIQ]}>
                <Enrollment organizationId={isEmpty(selectedOrganization) ? null : selectedOrganization.id}/>
                <Engagement organizationId={isEmpty(selectedOrganization) ? null : selectedOrganization.id}/>
                <Redemption organizationId={isEmpty(selectedOrganization) ? null : selectedOrganization.id}/>
                <CustomerLifetimeValue organizationId={isEmpty(selectedOrganization) ? null : selectedOrganization.id}/>
                <PercentOfRevenue organizationId={isEmpty(selectedOrganization) ? null : selectedOrganization.id}/>
            </TabPanel>
            <TabPanel index={RETAIL_TABS[RETAIL_REPORTS]}>
                <RetailCostAndMargin verticals={verticals} categories={categories} availableViews={availableViews}/>
            </TabPanel>
            <TabPanel index={RETAIL_TABS[RETAIL_PROCUREMENT]}>
                <RetailProcurement organizationId={isEmpty(selectedOrganization) ? null : selectedOrganization.id}/>
            </TabPanel>
            {/*<TabPanel index={RETAIL_TABS[RETAIL_EMPLOYEES]}>*/}
            {/*    Employees*/}
            {/*</TabPanel>*/}
        </Grid>
    </Grid>;
};

export default Retail;